export type BuyFeatureEvents = {
    'General.BuyFeature.OPEN': void;
    'General.BuyFeature.BUY': void;
    'General.BuyFeature.DECLINE': void;
    'General.BuyFeature.CLOSE': void;
};